const _excluded = ["type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useImperativeHandle, useMemo, useState } from 'react';
import cn from 'classnames';
import { Autocomplete, Checkbox, KeyboardDatePicker, MenuItem, TextButton, TextField, Typography, WithInfoIcon } from 'seagull';
import { priceIncreaseModel, serviceModel } from "../../models";
import styles from "./ServiceAdvancedSettings.module.scss";
import { AdvancedSetting, getSettings, getValidIncreaseOn } from "./ServiceAdvancedSettings.utils";
import { useIoContext, useStore, useStoreActions } from "../../contexts";
import { RoundPrices } from "../../models/price-increase";
import Decimal from 'decimal.js';
import { decimalFromStr } from "../../infra/utils";
import { utils } from "../../utils";
import { addYears, startOfYear } from 'date-fns';
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { selectors } from "../../store/state-selectors";
import { getPriceIncreaseDateRange } from "../../business-logic/priceIncreaseLogic";
const dropdownWidth = 274;
function AdvancedSettingsControl(props) {
  const {
    info,
    checked,
    testid,
    label,
    disabledTooltip,
    disabled,
    children,
    labelSuffix,
    onChange: _onChange
  } = props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: info
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    disabled: disabled,
    tooltip: disabled && disabledTooltip ? {
      placement: 'top',
      title: disabledTooltip
    } : undefined,
    "data-testid": testid,
    onChange: e => _onChange(e.target.checked)
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: disabled ? 'disabled' : 'standard'
  }, label))), labelSuffix), children);
}
function PausedControl(props) {
  const {
    service,
    testPrefix,
    disabled,
    info,
    label,
    disabledTooltip,
    onPausedChange
  } = props;
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.Pause,
    info: info,
    label: label,
    checked: serviceModel.isPaused(service),
    testid: testPrefix + '-start-paused',
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: checked => onPausedChange && onPausedChange(service.id, checked)
  });
}
function BillOnApprovalControl(props) {
  const {
    service,
    testPrefix,
    disabled,
    label,
    disabledTooltip,
    info,
    onBillOnAcceptanceChange
  } = props;
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.BillOnApproval,
    info: info,
    label: label,
    checked: !serviceModel.isSkipBillingOnAcceptance(service),
    testid: testPrefix + '-bill-on-acceptance',
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: checked => onBillOnAcceptanceChange && onBillOnAcceptanceChange(service.id, checked)
  });
}
function ProrateControl(props) {
  const {
    service,
    testPrefix,
    disabled,
    disabledTooltip,
    label,
    info,
    onProratedChange
  } = props;
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.Prorate,
    info: info,
    label: label,
    checked: serviceModel.isProrated(service),
    testid: testPrefix + '-prorated',
    disabled: disabled,
    disabledTooltip: disabledTooltip,
    onChange: checked => onProratedChange && onProratedChange(service.id, checked)
  });
}
function OptionalControl(props) {
  const {
    service,
    info,
    label,
    onOptionalChange
  } = props;
  const {
    logBI
  } = useStoreActions();
  const onChangeWithBI = data => {
    logBI(10488, _objectSpread(_objectSpread({}, data), {}, {
      serviceId: service.id,
      serviceName: service.name
    }));
    onOptionalChange && onOptionalChange(service.id, data.optional, data.includedByDefault);
  };
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.Optional,
    info: info,
    label: label,
    checked: service.participation.type === 'optional',
    testid: "".concat(service.id, "-toggle-optional"),
    onChange: checked => onChangeWithBI({
      optional: checked,
      includedByDefault: false
    })
  }, serviceModel.isOptional(service.participation) && /*#__PURE__*/React.createElement("div", {
    className: styles.additionalControl
  }, /*#__PURE__*/React.createElement(Typography, null, "Set the default state of this service:"), /*#__PURE__*/React.createElement(TextField, {
    select: true,
    size: "small",
    width: dropdownWidth,
    "data-testid": "".concat(service.id, "-included-dropdown"),
    value: service.participation.optional.includedByDefault.toString(),
    onChange: e => onChangeWithBI({
      optional: true,
      includedByDefault: e.target.value === 'true'
    })
  }, /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "".concat(service.id, "-option-not-included"),
    value: "false"
  }, "Not included in the proposal"), /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "".concat(service.id, "-option-included"),
    value: "true"
  }, "Included in the proposal"))));
}
function LimitChargesControl(props) {
  const {
    service,
    showServiceValidationWarning = false,
    info,
    label,
    onLimitBillingTimesChange
  } = props;
  const {
    logBI
  } = useStoreActions();
  const [wasModified, setWasModified] = useState(false);
  const maxChargesError = serviceModel.validateMaxCharges(service).length > 0;
  const onChangeWithBI = data => {
    logBI(10489, _objectSpread(_objectSpread({}, data), {}, {
      serviceId: service.id,
      serviceName: service.name
    }));
    onLimitBillingTimesChange && onLimitBillingTimesChange(service.id, data.limit, data.count);
  };
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.LimitCharges,
    info: info,
    label: label,
    checked: serviceModel.maxChargesEnabled(service),
    testid: "".concat(service.id, "-toggle-limit-billing-count"),
    onChange: checked => onChangeWithBI({
      limit: checked,
      count: serviceModel.maxChargesLimit(service)
    })
  }, serviceModel.maxChargesEnabled(service) && /*#__PURE__*/React.createElement("div", {
    className: styles.additionalControl
  }, /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    label: "Number of times",
    width: dropdownWidth,
    "data-testid": "".concat(service.id, "-limit-billing-count-input"),
    value: serviceModel.maxChargesLimit(service) != null ? serviceModel.maxChargesLimit(service) : '',
    error: maxChargesError && (wasModified || showServiceValidationWarning),
    onChange: e => {
      if (e.target.value !== '' && !Number.isNaN(Number(e.target.value))) {
        setWasModified(true);
        onChangeWithBI({
          limit: true,
          count: Number(e.target.value)
        });
      } else if (e.target.value === '') {
        setWasModified(true);
        onChangeWithBI({
          limit: true,
          count: null
        });
      }
    },
    helperText: maxChargesError && (wasModified || showServiceValidationWarning) ? 'Must be between 1 and 99' : ''
  })));
}
export let IncreaseMethod = /*#__PURE__*/function (IncreaseMethod) {
  IncreaseMethod["EffectiveDate"] = "effectiveDate";
  IncreaseMethod["Date"] = "date";
  return IncreaseMethod;
}({});
const increaseMethodToText = {
  [IncreaseMethod.EffectiveDate]: 'Every year on agreement anniversary',
  [IncreaseMethod.Date]: 'Every year starting on'
};
const increaseMethodOptions = [{
  value: IncreaseMethod.EffectiveDate
}, {
  value: IncreaseMethod.Date
}];
const roundPricesOptions = [{
  value: RoundPrices.Down1,
  amount: 1
}, {
  value: RoundPrices.Down5,
  amount: 5
}, {
  value: RoundPrices.Down10,
  amount: 10
}];
function getInitialIncreaseMethod(priceIncrease, relationshipState) {
  if (priceIncrease) {
    return priceIncrease.increaseOn ? IncreaseMethod.Date : IncreaseMethod.EffectiveDate;
  } else {
    return relationshipState.type === 'awaitingApproval' && !relationshipState.awaitingApproval.effectiveDate ? IncreaseMethod.EffectiveDate : IncreaseMethod.Date;
  }
}
function AutoPriceIncreaseControl(props) {
  const {
    service,
    info,
    label,
    showServiceValidationWarning,
    relationshipState,
    onAutoPriceIncreaseChange
  } = props;
  const disableIncreaseOnAnniversary = relationshipState.type === 'approved';
  const priceIncrease = serviceModel.priceIncrease(service);
  const {
    getNow
  } = useIoContext();
  const [roundPrices, setRoundPrices] = useState((priceIncrease === null || priceIncrease === void 0 ? void 0 : priceIncrease.roundPrices) || RoundPrices.None);
  const [increaseOn, setIncreaseOn] = useState(() => (priceIncrease === null || priceIncrease === void 0 ? void 0 : priceIncrease.increaseOn) || startOfYear(addYears(getNow(), 1)));
  const [increaseMethod, setIncreaseMethod] = useState(getInitialIncreaseMethod(priceIncrease, relationshipState));
  const [percentIncrease, setPercentIncrease] = useState(!priceIncrease || priceIncrease.percentIncrease.toNumber() < 0 ? '' : priceIncrease.percentIncrease.toString());
  const nextYearPrice = serviceModel.nextYearPrice(service);
  const hasPriceIncrease = !!priceIncrease;
  const shouldRoundPrices = roundPrices !== RoundPrices.None;
  const roundPricesError = showServiceValidationWarning && serviceModel.isInvalidRoundPrices(service) ? serviceModel.roundPricesErrorMsg : null;
  const relationshipEffectiveDate = relationshipState.type === 'approved' ? null : relationshipState.awaitingApproval.effectiveDate;
  const increaseMethodError = serviceModel.isInvalidIncreaseMethod(increaseMethod === IncreaseMethod.Date ? increaseOn : null, relationshipEffectiveDate) ? "Only available when the effective date is 'On Acceptance'." : null;
  const {
    minDate,
    maxDate
  } = useMemo(() => {
    return getPriceIncreaseDateRange(getNow(), relationshipEffectiveDate);
  }, [relationshipEffectiveDate]);
  function handleStateChange(data) {
    if (!onAutoPriceIncreaseChange) return;
    const {
      newIncreaseOn = increaseOn,
      newPercentIncrease = percentIncrease,
      newRoundPrices = roundPrices,
      newIncreaseMethod = increaseMethod
    } = data;
    const validNewIncreaseOn = getValidIncreaseOn(newIncreaseOn, getNow());
    setIncreaseOn(validNewIncreaseOn);
    setPercentIncrease(newPercentIncrease);
    setRoundPrices(newRoundPrices);
    setIncreaseMethod(newIncreaseMethod);
    const priceIncrease = data.enabled ? priceIncreaseModel.makePriceIncrease(newRoundPrices, decimalFromStr(newPercentIncrease) || new Decimal(-1), newIncreaseMethod === IncreaseMethod.Date ? validNewIncreaseOn : null) : null;
    onAutoPriceIncreaseChange(service.id, priceIncrease);
  }
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.AutoPriceIncrease,
    info: info,
    label: label,
    labelSuffix: hasPriceIncrease && /*#__PURE__*/React.createElement(Typography, {
      skin: "warning",
      weight: "normal",
      variant: "paragraph2",
      "data-testid": "price-increase-next-year"
    }, "Next year's price: ", nextYearPrice ? utils.formatDollarAmount(nextYearPrice) : ''),
    checked: hasPriceIncrease,
    testid: "".concat(service.id, "-toggle-price-increase"),
    onChange: checked => handleStateChange({
      enabled: checked
    })
  }, hasPriceIncrease && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.additionalControl
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.noShrink
  }, "increase by"), /*#__PURE__*/React.createElement(TextField, {
    isMoney: true,
    testid: "price-increase-amount",
    className: styles.noShrink,
    inputProps: {
      min: 0
    },
    size: "small",
    suffix: "%",
    width: 90,
    value: percentIncrease,
    onChange: e => handleStateChange({
      enabled: true,
      newPercentIncrease: e.target.value
    }),
    error: showServiceValidationWarning && serviceModel.isInvalidPercentIncrease(percentIncrease)
  }), disableIncreaseOnAnniversary ? /*#__PURE__*/React.createElement(Typography, {
    className: styles.noShrink
  }, increaseMethodToText[IncreaseMethod.Date]) : /*#__PURE__*/React.createElement(TextField, {
    select: true,
    size: "small",
    testid: "price-increase-method",
    value: increaseMethod,
    error: !!increaseMethodError,
    helperText: increaseMethodError,
    onChange: e => handleStateChange({
      enabled: true,
      newIncreaseMethod: e.target.value
    })
  }, increaseMethodOptions.map(_ref => {
    let {
      value
    } = _ref;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value,
      "data-testid": "price-increase-method-".concat(value)
    }, increaseMethodToText[value]);
  })), increaseMethod === IncreaseMethod.Date && increaseOn && /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    style: {
      width: 150
    },
    size: "small",
    "data-testid": "price-increase-date",
    className: styles.noShrink,
    value: increaseOn,
    minDate: minDate,
    maxDate: maxDate,
    disableErrors: !showServiceValidationWarning,
    helperText: "",
    onChange: newIncreaseOn => newIncreaseOn && handleStateChange({
      enabled: true,
      newIncreaseOn
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.additionalControl, styles.roundPrices)
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: styles.noShrink,
    checked: shouldRoundPrices,
    "data-testid": "price-increase-should-round-prices",
    onChange: e => handleStateChange({
      enabled: true,
      newRoundPrices: e.target.checked ? RoundPrices.Down1 : RoundPrices.None
    })
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: "Automatically rounds prices down to the nearest whole number for customer-friendly pricing."
  }, /*#__PURE__*/React.createElement(Typography, null, "Round prices"))), shouldRoundPrices && /*#__PURE__*/React.createElement(TextField, {
    select: true,
    size: "small",
    testid: "price-increase-round-prices",
    width: 360,
    value: roundPrices,
    error: !!roundPricesError,
    helperText: roundPricesError,
    onChange: e => handleStateChange({
      enabled: true,
      newRoundPrices: e.target.value
    })
  }, roundPricesOptions.map(_ref2 => {
    let {
      value,
      amount
    } = _ref2;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value,
      "data-testid": "price-increase-round-prices-".concat(value)
    }, "Round prices down to the nearest ", utils.formatDollarAmount(amount));
  })))));
}
function QboClassesControl(props) {
  const {
    qboClasses,
    info,
    label,
    service,
    testPrefix,
    showServiceValidationWarning,
    onQboClassChange = () => {}
  } = props;
  const integratedClassId = serviceModel.integratedClassId(service);
  const checked = integratedClassId != null;
  const errors = serviceModel.validateIntegratedClass(service);
  const selectedOption = useMemo(() => {
    return integratedClassId ? qboClasses.find(qboClass => qboClass.id === integratedClassId) : undefined;
  }, [integratedClassId, qboClasses]);
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.QboClasses,
    info: info,
    label: label,
    checked: checked,
    testid: "".concat(testPrefix, "-toggle-qbo-classes"),
    onChange: newChecked => {
      const newIntegratedClass = newChecked ? serviceModel.makeIntegratedClassSet('') : serviceModel.makeIntegratedClassUnset();
      onQboClassChange(service.id, newIntegratedClass);
    }
  }, checked && /*#__PURE__*/React.createElement("div", {
    className: styles.additionalControl
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    selectOnFocus: true,
    freeSolo: true,
    multiple: false,
    size: "small",
    value: selectedOption,
    "data-testid": "".concat(testPrefix, "-select-qbo-class"),
    textFieldProps: {
      label: 'Class',
      placeholder: 'Select class',
      alwaysShrinkLabel: true,
      width: dropdownWidth,
      error: showServiceValidationWarning && errors.length > 0,
      helperText: showServiceValidationWarning && errors[0]
    },
    options: qboClasses,
    onChange: (_, newOption) => {
      const id = !newOption || typeof newOption === 'string' ? '' : newOption.id;
      onQboClassChange(service.id, serviceModel.makeIntegratedClassSet(id));
    },
    getOptionLabel: option => !option ? '' : typeof option == 'string' ? option : option.name
  })));
}
export const ServiceAdvancedSettings = /*#__PURE__*/React.forwardRef(function ServiceAdvancedSettings(props, ref) {
  const {
    service,
    testPrefix,
    showServiceValidationWarning,
    relationshipState
  } = props;
  const {
    QBO_CLASSES = false
  } = useFeatureFlags();
  const qboClasses = useStore(state => state.qboClasses.data);
  const allowToCustomizeQboClasses = useStore(selectors.integration.allowToCustomizeQboClasses);
  const isApprovedRelationship = relationshipState.type === 'approved';
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(serviceModel.isProrated(service) || serviceModel.isOptional(service.participation));
  const settings = getSettings({
    service,
    isApprovedRelationship,
    allowToCustomizeQboClasses,
    QBO_CLASSES
  });
  useImperativeHandle(ref, () => ({
    showAdvancedSettings
  }), [showAdvancedSettings]);
  useEffect(() => {
    if (showServiceValidationWarning) {
      setShowAdvancedSettings(true);
    }
  }, [showServiceValidationWarning]);
  return settings.length === 0 ? null : showAdvancedSettings ? /*#__PURE__*/React.createElement("div", {
    className: styles.settings,
    "data-testid": testPrefix + '-advanced-settings'
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "normal"
  }, "Advanced settings:"), settings.map(_ref3 => {
    let {
        type
      } = _ref3,
      rest = _objectWithoutProperties(_ref3, _excluded);
    const controlProps = _objectSpread(_objectSpread({
      key: type
    }, props), rest);
    switch (type) {
      case AdvancedSetting.Pause:
        return /*#__PURE__*/React.createElement(PausedControl, controlProps);
      case AdvancedSetting.BillOnApproval:
        return /*#__PURE__*/React.createElement(BillOnApprovalControl, controlProps);
      case AdvancedSetting.Prorate:
        return /*#__PURE__*/React.createElement(ProrateControl, controlProps);
      case AdvancedSetting.Optional:
        return /*#__PURE__*/React.createElement(OptionalControl, controlProps);
      case AdvancedSetting.LimitCharges:
        return /*#__PURE__*/React.createElement(LimitChargesControl, controlProps);
      case AdvancedSetting.AutoPriceIncrease:
        return /*#__PURE__*/React.createElement(AutoPriceIncreaseControl, controlProps);
      case AdvancedSetting.QboClasses:
        return qboClasses !== null && qboClasses !== void 0 && qboClasses.length ? /*#__PURE__*/React.createElement(QboClassesControl, _extends({}, controlProps, {
          qboClasses: qboClasses
        })) : /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  })) : /*#__PURE__*/React.createElement(TextButton, {
    underline: "hover",
    "data-testid": testPrefix + '-open-adv-settings',
    onClick: () => setShowAdvancedSettings(true)
  }, "Show Advanced settings...");
});